export default {"src":"/_next/static/media/icLogo.37c983b7.svg","height":32,"width":20,"blurWidth":0,"blurHeight":0};